import { getTotalPrice } from '@pages/CoursesCatalog/modals/CourseEnrollmentModal/utils/tariff'
import { parseAndValidateAddedCourses } from './components/SelectAdditionalCourses/utils/parseAddedCourses'

type CourseLike = {
  id?: number | null
}

export const getCreateLinkTotalPrice = ({
  streamPackageTotal,
  isStreamActive,
  individualTotalPrice,
  isIndividualActive,
  selectedTariff,
  valueWatch,
  additionalCoursesWatch,
  courses,
  extraCoursesDiscountsRaw,
  extraCoursesDiscountUnit,
}: {
  streamPackageTotal: number
  isStreamActive: boolean
  individualTotalPrice: number
  isIndividualActive: boolean
  selectedTariff?: ICourseTariff | null
  valueWatch: number | null
  additionalCoursesWatch?: string | null
  courses?: CourseLike[] | null
  extraCoursesDiscountsRaw?: string | null
  extraCoursesDiscountUnit?: string | null
}) => {
  if (isStreamActive) return streamPackageTotal
  if (isIndividualActive) return individualTotalPrice
  if (!selectedTariff) return 0

  // free: value в форме null — основной = 0, в пакет всё равно входят допы.
  const isFreeMain = selectedTariff.type === 'free'
  if (!isFreeMain && !valueWatch) return 0

  const additionalCourses = parseAndValidateAddedCourses(
    additionalCoursesWatch ?? null,
  ).map((item) => ({
    ...item,
    course: courses?.find((course) => course.id === item.courseId) ?? null,
    withDemo: false,
  }))

  let extraCoursesDiscounts: number[] = []
  try {
    extraCoursesDiscounts =
      JSON.parse(extraCoursesDiscountsRaw ?? 'null') ?? []
  } catch (error) {}

  const coursesWithFixedPrice = additionalCourses.filter(
    (item) => item.price !== null && item.price !== undefined,
  )
  const coursesForDefaultCalculation = additionalCourses.filter(
    (item) => item.price === null || item.price === undefined,
  )
  const fixedAdditionalCoursesPrice = coursesWithFixedPrice.reduce(
    (sum, item) => {
      const price = Number(item.price)
      return sum + (Number.isFinite(price) ? price : 0)
    },
    0,
  )

  return (
    getTotalPrice(
      selectedTariff,
      isFreeMain ? 1 : valueWatch ?? undefined,
      undefined,
      false,
      coursesForDefaultCalculation as any,
      extraCoursesDiscounts,
      extraCoursesDiscountUnit ?? 'percent',
    ) + fixedAdditionalCoursesPrice
  )
}
